import React from 'react'
// eslint-disable-next-line react/prop-types
const DoubleArrowNext =({className}) =>
<svg className={className} width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 10.59L4.58 6L0 1.41L1.41 0L7.41 6L1.41 12L0 10.59Z" fill="#41A017"/>
<path d="M7 10.59L11.58 6L7 1.41L8.41 0L14.41 6L8.41 12L7 10.59Z" fill="#41A017"/>
</svg>


export default DoubleArrowNext
